import { createContext } from 'react';

const nivel2Context = createContext();

export default nivel2Context;